import { colors } from '../constants';
const styleOverrides = {
  switchBase: {
    color: colors.oriGrey[100]
  },
  track: {
    opacity: 0.103
  }
};
export default {
  styleOverrides
};